import { useAssetsContext } from '../providers/AssetsProvider';
import { isAssetSpot } from '../types/Asset';

/**
 * Resolves the display unit for an asset amount using showInTermsOfContracts-style
 * contract quantity semantics. `undefined` means the formatted amount has no unit.
 */
export function useAssetAmountDisplayUnit(asset: string): string | undefined {
  const { getAssetDisplaySymbol, resolveSecurityOrCurrency } = useAssetsContext();
  const resolved = resolveSecurityOrCurrency(asset);

  if (resolved.security && !isAssetSpot(resolved)) {
    return undefined;
  }

  const displaySymbol = getAssetDisplaySymbol(asset);
  return displaySymbol || asset || undefined;
}
